var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSwapIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.36364 11.0909C4.36364 10.7562 4.63498 10.4848 4.9697 10.4848H14.0606C14.3953 10.4848 14.6667 10.7562 14.6667 11.0909C14.6667 11.4256 14.3953 11.697 14.0606 11.697H4.9697C4.63498 11.697 4.36364 11.4256 4.36364 11.0909Z",
    fill: "white",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2078 8.23812C11.4445 8.00144 11.8282 8.00144 12.0649 8.23812L14.4892 10.6624C14.7258 10.899 14.7258 11.2828 14.4892 11.5195L12.0649 13.9437C11.8282 14.1804 11.4445 14.1804 11.2078 13.9437C10.9711 13.707 10.9711 13.3233 11.2078 13.0866L13.2035 11.0909L11.2078 9.09522C10.9711 8.85853 10.9711 8.4748 11.2078 8.23812Z",
    fill: "white",
    fillOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.33333 5.0303C1.33333 4.69559 1.60467 4.42424 1.93939 4.42424H11.6364C11.9711 4.42424 12.2424 4.69559 12.2424 5.0303C12.2424 5.36502 11.9711 5.63636 11.6364 5.63636H1.93939C1.60467 5.63636 1.33333 5.36502 1.33333 5.0303Z",
    fill: "white",
    fillOpacity: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.79218 2.17751C5.02887 2.41419 5.02887 2.79793 4.79218 3.03461L2.79649 5.0303L4.79218 7.026C5.02887 7.26268 5.02887 7.64641 4.79218 7.88309C4.5555 8.11978 4.17177 8.11978 3.93509 7.88309L1.51084 5.45885C1.27416 5.22217 1.27416 4.83843 1.51084 4.60175L3.93509 2.17751C4.17177 1.94083 4.5555 1.94083 4.79218 2.17751Z",
    fill: "white",
    fillOpacity: 0.6
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwapIcon);
export default __webpack_public_path__ + "static/media/swap_icon.b2492adbf2b4bb48071cdc99b85c7837.svg";
export { ForwardRef as ReactComponent };